import FlickityComponent from 'components/flickity/flickity';
import { ImageBlock } from 'components/general/blocks/imageBlock/ImageBlock';
import { useWindowSize } from 'hooks/useWindowSize';
import { ProjectType } from 'pages/work/[slug]';
import { useRef } from 'react';
import { isBrowser, isMobileWidth } from 'utils/helpers';

import gsap from 'gsap/dist/gsap';
import { TextPlugin } from 'gsap/dist/TextPlugin';

import style from './MobileProjectCarousel.module.scss';
import Link from 'next/link';

if (isBrowser()) {
  // Due to SSR we can only register when we are in the browser
  gsap.registerPlugin(TextPlugin);
}

export type MobileProjectCarouselType = {
  projects: ProjectType[];
  currentProjectSlug: string;
};

export const MobileProjectCarousel = ({
  projects,
  currentProjectSlug,
}: MobileProjectCarouselType): JSX.Element => {
  const windowSize = useWindowSize();
  const isMobileScreen = isMobileWidth(windowSize.width);
  const flickityRef = useRef<any>();

  const currentIndexOfProject = projects.findIndex(
    (project) => project.slug === currentProjectSlug,
  );

  const nextIndex = currentIndexOfProject + 1 > projects.length - 1 ? 0 : currentIndexOfProject + 1;

  const images = projects.map((project, index) => {
    const mediaItem = project.hero;

    const width = (isMobileScreen && mediaItem.phone_image) ? mediaItem.phone_image_width : mediaItem.image_width;
    const height = (isMobileScreen && mediaItem.phone_image) ? mediaItem.phone_image_height : mediaItem.image_height;
    const aspectRatio = `${width} / ${height}`;
    const containerStyle = { aspectRatio };
    return (
      <Link href={`/work/${project.slug}`} key={index}>
        <div className={`${style.slide} block-gallery`}>
          <div className={`${style.imageContainer}`} style={containerStyle}>
            <ImageBlock
              desktop={{
                layout: 'fill',
                objectFit: 'cover',
                src: mediaItem.image,
                priority: true,
              }}
              mobile={{
                layout: 'fill',
                objectFit: 'cover',
                src: mediaItem.phone_image || mediaItem.image,
                priority: true,
              }}
              alt={mediaItem.alt_text}
            />
          </div>
          <div
            className={`${style.projectTitle2} js-mobile-carousel-title2`}
            dangerouslySetInnerHTML={{ __html: project.title }}
          ></div>
        </div>
      </Link>
    );
  });

  return (
    <div className={`${style.viewport} `}>
      <FlickityComponent
        className={style.carousel}
        flickityRef={(c) => {
          flickityRef.current = c;
          flickityRef.current.on('ready', () => {
            const title = projects[flickityRef.current.selectedIndex].title;
            gsap.set('.js-mobile-carousel-title', {
              text: {
                value: title,
                delimiter: '',
                type: 'diff',
              },
            });
          });
          flickityRef.current.on('dragStart', () => {
            //
            gsap.to('.js-mobile-carousel-title', { alpha: 0 });
          });

          flickityRef.current.on('settle', () => {
            const title = projects[flickityRef.current.selectedIndex].title;
            //
            gsap.set('.js-mobile-carousel-title', { alpha: 0 });
            gsap.set('.js-mobile-carousel-title', {
              text: {
                value: title,
                delimiter: '',
                type: 'diff',
              },
            });
            gsap.to('.js-mobile-carousel-title', { alpha: 1 });
          });
        }}
        options={{
          pageDots: false,
          prevNextButtons: false,
          cellAlign: 'center',
          wrapAround: true,
          freeScroll: true,
          initialIndex: nextIndex,
        }}
        // IMPORTANT: not recommended but on this specfic project we can't have it render in a portal
        static
      >
        {/* <Drag>{images}</Drag> */}
        {images}
      </FlickityComponent>
      {/* <p className={`${style.projectTitle} js-mobile-carousel-title`}></p> */}
    </div>
  );
};
